import React, { useState, useEffect } from "react";
import "../css/Login.css";
import api from '../api';
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
// import DisclaimerPopup from "./DisclaimerPopup";
import { resetSidebarState } from "../redux/sidebarSlice";
import { useDispatch } from "react-redux";


const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [termsConditions, setTermsConditions] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [termsError, setTermsError] = useState(false);

  // ✅ Auto login check
useEffect(() => {
  const storedUser = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user"));
  const storedAccessToken = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

  if (storedUser && storedAccessToken) {
    setLoginData({
      access_token: storedAccessToken,
      refresh_token: localStorage.getItem("refresh_token") || sessionStorage.getItem("refresh_token"),
      user: storedUser,
      session_id: localStorage.getItem("session_id") || sessionStorage.getItem("session_id"),
    });

    if (storedUser.termsAccepted) setTermsConditions(true);
    proceedToDashboard(storedUser, storedAccessToken);
  }
}, []);


  // ✅ Handle storage changes across tabs
useEffect(() => {
  const handleStorageChange = () => {
    const storedUser = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user"));
    const storedAccessToken = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

    if (storedUser && storedAccessToken) {
      setLoginData({
        access_token: storedAccessToken,
        refresh_token: localStorage.getItem("refresh_token") || sessionStorage.getItem("refresh_token"),
        user: storedUser,
        session_id: localStorage.getItem("session_id") || sessionStorage.getItem("session_id"),
      });

      if (storedUser.termsAccepted) setTermsConditions(true);
    } else {
      setLoginData(null);
      navigate("/");
    }
  };

  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
}, [navigate]);


const handleLogin = async (e) => {
  e.preventDefault();
  if (loading) return;

  if (!termsConditions) {
    setTermsError(true);
    return;
  }

  setLoading(true);
  try {
    const response = await api.post(`${process.env.REACT_APP_API_URL}/auth/login`, { email, password });
    const { access_token, refresh_token, user, session_id,api_key } = response.data;

    setLoginData({ access_token, refresh_token, session_id, user });

    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("session_id", session_id);
    localStorage.setItem("api_key", api_key);

    sessionStorage.setItem("access_token", access_token);
    sessionStorage.setItem("refresh_token", refresh_token);
    sessionStorage.setItem("user", JSON.stringify(user));
    sessionStorage.setItem("session_id", session_id);
    sessionStorage.setItem("api_key", api_key);

    proceedToDashboard(user, access_token);
  } catch (err) {
    showErrorToast(err.response?.data?.message || TOAST_MESSAGES.AUTH.LOGIN_FAILED);
  } finally {
    setLoading(false);
  }
};



 const proceedToDashboard = async (user, token) => {
  try {
    showSuccessToast(TOAST_MESSAGES.AUTH.LOGIN_SUCCESS);

    const rolesResponse = await api.get("/roles", {
      headers: { Authorization: `Bearer ${token}` },
    });

    const roles = rolesResponse.data || [];
    const userRole = roles.find((role) => role.role_id === user.role_fid);

    if (userRole) {
      dispatch(resetSidebarState());
      switch (userRole.role_name) {
        case "Superadmin":
          navigate("/superadmin/dashboard");
          break;
        case "Admin":
          navigate("/admin/dashboard");
          break;
        case "User":
          navigate("/user/new");
          break;
        default:
          navigate("/");
      }
    } else {
      showErrorToast(TOAST_MESSAGES.AUTH.NO_ROLE);
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  } catch (error) {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }
};


  return (
    <div className="login-container">
      <div className="login-left"></div>

      <div className="login-right d-flex flex-column align-items-center justify-content-center">
        <div className="logo-wrapper">
          <img
            className="zerobox-logo"
            src="/asset/Domatrix_Logo_White_crop.png"
            alt="Domatrix Logo"
          />
        </div>
        <form
          className="login-formrounded-3 "
          onSubmit={handleLogin}
          // style={{ maxWidth: "420px", width: "100%" }}
        >
          <h3 className="my-4 refresh-prompts text-center fw-bolder">
            Welcome Back
          </h3>
          <p className="text-center login-p mx-3 refresh-prompts">
            Enter your email address and password to login.
          </p>

          {/* Email Input */}
          <div className="w-100 mb-4">
            <div
              className="rounded input-group custom-search-group bg-black"
              // style={{ maxWidth: "420px", width: "100%" }}
            >
              <span className="input-group-text">
                <i className="bi bi-envelope-fill"></i>
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity(
                    "Please enter a valid email address."
                  )
                }
                onInput={(e) => e.target.setCustomValidity("")}
              />
            </div>
          </div>

          {/* Password Input */}
          <div className="rounded w-100 mb-4">
            <div className="input-group custom-search-group"
             style={{ maxWidth: "420px", width: "100%" }}
            >
              <span className="input-group-text">
                <i className="bi bi-lock-fill"></i>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                onInvalid={(e) =>
                  e.target.setCustomValidity(
                    "Password is required and must be at least 6 characters."
                  )
                }
                onInput={(e) => e.target.setCustomValidity("")}
              />
              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </span>
            </div>
          </div>

          {/* Remember Me & Forgot Password */}
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span
                className="form-check-label refresh-prompts"
                htmlFor="rememberMe"
                style={{ fontSize: "0.8rem" }}
              >
                Remember me
              </span>
            </div>
            <Link
              to="/forgot-password"
              className="text-decoration-none small"
              style={{ fontSize: "0.8rem" }}
            >
              Forgot Password?
            </Link>
          </div>

          {/* Terms & Conditions */}
          <div className="form-check mb-4 d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className={`form-check-input mt-1 ${
                termsError ? "border-danger" : ""
              }`}
              id="termsConditions"
              checked={termsConditions}
              onChange={(e) => {
                setTermsConditions(e.target.checked);
                setTermsError(false);
                e.target.setCustomValidity("");
              }}
              required
              onInvalid={(e) =>
                e.target.setCustomValidity(
                  "You must accept the Terms and Usage Policy."
                )
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
            <span
              className="form-check-label refresh-prompts"
              htmlFor="termsConditions"
              style={{ fontSize: "0.8rem", marginTop: "2px" }}
            >
              I agree to Domatrix Consumer 
              <Link to="/terms" className="text-decoration-none fw-bold ms-1">
                Terms and Usage Policy
              </Link>
              .
            </span>
          </div>

          {/* Login Button */}
          <button type="submit" className="custom-btn w-100" disabled={loading}>
            {loading ? "Logging In..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
